import { render, staticRenderFns } from "./RxDate.vue?vue&type=template&id=0c4f5ae8"
import script from "./RxDate.vue?vue&type=script&lang=js"
export * from "./RxDate.vue?vue&type=script&lang=js"
import style0 from "./RxDate.vue?vue&type=style&index=0&id=0c4f5ae8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports